import {ActionTree, ActionContext} from 'vuex';
import CatalogService from "@/services/CatalogService";

import {RootState} from '@/store';

import {State} from './state';
import {Mutations} from './mutations';
import {ProductMutationTypes} from './mutation-types';
import {ProductActionTypes} from './action-types';

import {FilterData, ProductData, ProductsLoadOptions} from "@/types";
import {useCatalogStore} from "@/store/catalog-store";

type AugmentedActionContext = {
    commit<K extends keyof Mutations>(
        key: K,
        payload?: Parameters<Mutations[K]>[1],
    ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
    [ProductActionTypes.SET_PRODUCTS](
        {commit}: AugmentedActionContext,
        data: FilterData
    ): void;

    [ProductActionTypes.SET_LOADING](
        {commit}: AugmentedActionContext,
    ): void;

    [ProductActionTypes.LOAD_PRODUCTS](
        {commit}: AugmentedActionContext,
        options: ProductsLoadOptions
    ): Promise<void>;
}

export const actions: ActionTree<State, RootState> & Actions = {
    [ProductActionTypes.SET_PRODUCTS]({commit}, data: FilterData) {
        commit(ProductMutationTypes.SET_PRODUCTS, data.products);
        commit(ProductMutationTypes.SET_PAGER, {
            pager: data.pager.items,
            nextPageUrl: data.nextPageUrl,
            nextPageLabel: data.nextPageLabel,
            backToTopLabel: data.backToTopLabel
        });

        useCatalogStore().initializeTmplComponents();
    },
    [ProductActionTypes.SET_LOADING]({commit}) {
        commit(ProductMutationTypes.SET_LOADING_STATUS);
    },
    async [ProductActionTypes.LOAD_PRODUCTS]({commit}, options: ProductsLoadOptions) {
        commit(ProductMutationTypes.SET_LOADING_STATUS);
        return CatalogService.getProductList(options.url, options.queryParams)
            .then((response: ProductData) => {
                console.log(response);
                commit(ProductMutationTypes.SET_PAGER, response);
                commit(options.appendProducts ? ProductMutationTypes.APPEND_PRODUCTS : ProductMutationTypes.SET_PRODUCTS, response.products);
                useCatalogStore().initializeTmplComponents();
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                commit(ProductMutationTypes.SET_LOADING_STATUS);
                CatalogService.writeHistory(options.url, options.queryParams);
            })
    },
};